
import Vue, { PropType } from 'vue';
import { VFairPavilion } from '~/services/types/vfair';
import Breadcrumb, { Crumb } from '~/shared/Breadcrumb.vue';
import URLS from '~/URLS';
import { uuidFromURLParam } from '~/utils/urlUtils';

export default Vue.extend({
    name: 'VFairBreadcrumb',
    components: {
        Breadcrumb,
    },
    props: {
        pavilion: {
            type: Object as PropType<VFairPavilion | null>,
            default: null,
        },
    },
    data() {
        return {
            breadcrumbs: [] as Crumb[],
        };
    },
    methods: {
        async updateBreadcrumb() {
            const vFairId = uuidFromURLParam(this.$route.params.id) || '';
            const vFairPath = URLS.vfairs.concat(
                '/',
                this.$route.params.id,
                this.$URLS.vfairDetails
            );

            const crumbs: Crumb[] = [
                {
                    text: this.$t('vfair.pavilionTabs.lobby').toString(),
                    to: vFairPath,
                },
            ];

            if (!!this.pavilion) {
                const pavilionPath = URLS.vfair.concat('/', vFairId, '/', this.pavilion.id);
                crumbs.push({
                    text: this.pavilion.title,
                    to: pavilionPath,
                    active: true,
                });
            }

            this.breadcrumbs = crumbs;
        },
    },
    watch: {
        $route() {
            this.updateBreadcrumb();
        },
        pavilion() {
            this.updateBreadcrumb();
        },
    },
    mounted() {
        this.updateBreadcrumb();
    },
});
